import React from "react";

import { LoadList } from "../../types/List";

const assetPrefix = process.env.ASSET_PREFIX || "";

interface RefreshListProps {
  action: LoadList;
}

export default function RefreshList({ action }: RefreshListProps) {
  return (
    <button
      data-type="tertiary"
      type="button"
      onClick={() => action()}
      data-testid="refresh"
    >
      <img src={`${assetPrefix}/static/refresh-icon.svg`} />
    </button>
  );
}
